<template>
	<canvas id="player" v-on:click="onCanvasClick"></canvas>
</template>

<script>

const PLAYER_MODE_NORMAL = 200701;
const PLAYER_MODE_RANDOM = 200702;

import EventBus from './EventBus'

export default {
	name: 'Player',
	props: ['can'],
	data: function() {
		return {
			canvas: {
				object:   null,
				context:  null,
				width:    null,
				height:   null,
				objects:  {},
			},
			audio: {
				object: document.createElement('audio'),
				bufferedProgress: {
					start:  0,
					end:    0,
				},
				playedProgress: 0,
				time: {
					duration:   0,
					current:    0,
				},
				mode: PLAYER_MODE_NORMAL,
				isScrobble: false,
			},
			mouse: {
				leftButtonDown: false,
				volumeDown:     false,
			},
		}
	},
	created() {
		EventBus.$on('playtrack', this.playTrack);
		this.audio.object.ontimeupdate 	= this.onTimeUpdate;
		this.audio.object.onplay 		= this.onPlay;
		this.audio.object.onpause 		= this.onPause;
		this.audio.object.onended 		= this.onEnd;

		var vol = localStorage.getItem('player_volume');

		if (vol == undefined)
			vol = 1.0;

		this.audio.object.volume = vol;
		this.audio.mode = parseInt(localStorage.getItem('player_mode'));

		window.addEventListener('resize', this.onWindowsResize);
		window.addEventListener('mousemove', this.onMouseMoved);
		window.addEventListener('mouseup', this.onMouseUp);
		window.addEventListener('mousedown', this.onMouseDown);
	},
	mounted() {
		this.canvas.object = player;
		this.canvas.context = this.canvas.object.getContext('2d');

		var progressBar = {
			width: 0,
			height: 4,
			x: 0,
			y: 0,
		}

		var volumeBar = {
			width: 60,
			height: 4,
			x: 0,
			y: 0
		}

		var playPauseButton = {
			width: 12,
			height: 12,
			x: 0,
			y: 0
		}

		var speakerButton = {
			width: 12,
			height: 12,
			x: 0,
			y: 0
		}
		var randomButton = {
			width: 20,
			height: 12,
			x: 0,
			y: 0
		}

		var previousButton = {
			width: 12,
			height: 12,
			x: 0,
			y: 0
		};

		var nextButton = {
			width: 12,
			height: 12,
			x: 0,
			y: 0
		};

		this.canvas.objects = {
			progressbar:  progressBar,
			playpausebtn: playPauseButton,
			speakerbtn:   speakerButton,
			volumebar:    volumeBar,
			randombtn:    randomButton,
			prevbtn:      previousButton,
			nextbtn:      nextButton
		};

		EventBus.$emit('playermodechanged', this.audio.mode);

		this.canvas.width 			= this.canvas.object.clientWidth;
		this.canvas.height 			= this.canvas.object.clientHeight;
		this.canvas.object.width 	= this.canvas.width;
		this.canvas.object.height 	= this.canvas.height;

		this.drawPlayer();
	},  
	methods: {
		secToTime(totalSeconds) {
			var minutes = Math.floor((totalSeconds) / 60);
			var seconds = totalSeconds - (minutes * 60);

			seconds = Math.floor(Math.round(seconds * 100) / 100);

			var  result = (minutes < 10 ? "0" + minutes : minutes);
			result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
			
			return result;
		},
		playTrack(url) {
			this.audio.object.src = url;
			this.audio.object.play();
			this.audio.isScrobble = false;
		},
		onTimeUpdate() {
			var audio = this.audio;

			audio.time.duration 	= audio.object.duration;
			audio.time.current 		= audio.object.currentTime;
			audio.playedProgress 	= 100 / (audio.time.duration / audio.time.current);

			if (audio.object.buffered.length > 0) {
				audio.bufferedProgress.start = (100 / (audio.object.duration / audio.object.buffered.start(0)));
				audio.bufferedProgress.end = (100 / (audio.object.duration / audio.object.buffered.end(0)));
			}

			if (audio.playedProgress >= 60 && audio.isScrobble == false) {
				audio.isScrobble = true;
				EventBus.$emit("onscrobble");
			}

			this.drawPlayer();
		},
		onPlay() {
			EventBus.$emit('playerplay');
			this.drawPlayer();
		},
		onPause() {
			EventBus.$emit('playerpause');
			this.drawPlayer();
		},
		onEnd() {
			EventBus.$emit('playerend');
			this.drawPlayer();
		},
		onMouseUp(event) {
			if (event.which === 1) {
				this.mouse.leftButtonDown = false;
				this.mouse.volumeDown = false;
			}
		},
		onMouseDown(event) {
			if (event.which === 1) {
				this.mouse.leftButtonDown = true;
			}
		},
		onMouseMoved(event) {
			var brect = this.canvas.object.getBoundingClientRect();

			var scaleX = this.canvas.width / brect.width;
			var scaleY = this.canvas.height / brect.height;

			var x = (event.clientX - brect.left) * scaleX;
			var y = (event.clientY - brect.top) * scaleY;

			var audio = this.audio;

			var canvas = this.canvas;
			var objects = canvas.objects;

			for (var objname in objects) {
				if (!objects.hasOwnProperty(objname))
					continue;

				var obj = objects[objname];

				switch (objname) {
					case 'volumebar': {
						if (this.mouse.volumeDown == false) {
							if (x >= obj.x && x <= obj.x + obj.width &&
								y > obj.y && y <= obj.y + obj.height) {
								canvas.object.style.cursor = 'pointer';
								if (this.mouse.leftButtonDown) {
									this.mouse.volumeDown = true;
								}
								return;
							} else {
								canvas.object.style.cursor = 'default';
							}
						} else {
							canvas.object.style.cursor = 'pointer';
							var x = event.offsetX - obj.x;
							var val = 1.0 / (obj.width / x);
							if (val < 0.0) 
								val = 0.0;
							if (val > 1.0)
								val = 1.0;
							audio.object.volume = val;
							localStorage.setItem('player_volume', val);
							this.drawPlayer();
						}
						break;
					}
					case 'prevbtn': {
						if (this.can.prev == false) {
							break;
						}
					}
					case 'nextbtn': {
						if (this.can.next == false) {
							break;
						}
					}
					default: {
						if (x >= obj.x && x <= obj.x + obj.width &&
							y > obj.y && y <= obj.y + obj.height) {
							canvas.object.style.cursor = 'pointer';
							return;
						} else {
							canvas.object.style.cursor = 'default';
						}
					}
				}
			}
		},
		onCanvasClick(event) {
			var brect = this.canvas.object.getBoundingClientRect();

			var scaleX = this.canvas.width / brect.width;
			var scaleY = this.canvas.height / brect.height;

			var x = (event.clientX - brect.left) * scaleX;
			var y = (event.clientY - brect.top) * scaleY;

			var audio = this.audio;

			var objects = this.canvas.objects;

			for (var objname in objects) {
				if (!objects.hasOwnProperty(objname))
					continue;

				var obj = objects[objname];
				if (x >= obj.x && x <= obj.width + obj.x) {
					if (y => obj.y && y <= obj.height + obj.y) {
						switch(objname) {
							case 'nextbtn': {
								if (this.can.next)
									EventBus.$emit('onnextbtn');
								return;
							}
							case 'prevbtn': {
								if (this.can.prev)
									EventBus.$emit('onprevbtn');
								return;
							}
							case 'progressbar': {
								var max = obj.width;
								var current = 100 / (max / (x - obj.x));
								audio.object.currentTime = (audio.object.duration / 100) * current;
								break;
							}
							case 'volumebar': {
								var v_x = event.offsetX - obj.x;
								var val = 1.0 / (obj.width / v_x);
								if (val < 0.0) 
									val = 0.0;
								if (val > 1.0)
									val = 1.0;
								audio.object.volume = val;
								localStorage.setItem('player_volume', val);
								break;
							}
							case 'playpausebtn': {
								if (audio.object.paused) {
									audio.object.play();
								} else {
									audio.object.pause();
								}
								break;
							}
							case 'randombtn': {
								if (this.audio.mode == PLAYER_MODE_NORMAL) {
									this.audio.mode = PLAYER_MODE_RANDOM;
								} else {
									this.audio.mode = PLAYER_MODE_NORMAL;
								}
								localStorage.setItem('player_mode', this.audio.mode);
								EventBus.$emit('playermodechanged', this.audio.mode);
							}
						}
						this.drawPlayer();
					}
				}
			}
		},
		onWindowsResize() {
			this.drawPlayer();
		},

		drawPlayer() {
			this.canvas.width 			= this.canvas.object.clientWidth;
			this.canvas.height 			= this.canvas.object.clientHeight;
			this.canvas.object.width 	= this.canvas.width;
			this.canvas.object.height 	= this.canvas.height;

			var audio = this.audio;

			var cnv = this.canvas;
			var ctx = cnv.context;

			var width = this.canvas.width;
			var height = this.canvas.height;

			var playPauseButton = cnv.objects.playpausebtn;
			var progressBar 	= cnv.objects.progressbar;
			var volumeBar 		= cnv.objects.volumebar;
			var speakerButton 	= cnv.objects.speakerbtn;
			var randomButton 	= cnv.objects.randombtn;
			var previousButton 	= cnv.objects.prevbtn;
			var nextButton 		= cnv.objects.nextbtn;

			if (isNaN(audio.time.duration)) {
				audio.time.duration = 0; 
			}

			if (isNaN(audio.time.current)) {
				audio.time.current = 0;
			}

			var durationTime 	= this.secToTime(audio.time.duration);
			var currentTime 	= this.secToTime(audio.time.current);

			ctx.font = "12px Helvetica";

			var metrics 		= ctx.measureText(durationTime);
			var textWidth 		= Math.round(metrics.width);

			var separator 		= 10;
			var leftOffset 		= playPauseButton.width + separator;
			leftOffset 			+= previousButton.width + separator;
			leftOffset 			+= nextButton.width + separator;

			var rightOffset 	= volumeBar.width + separator + randomButton.width + separator + speakerButton.width + separator;
			var barLeftOffset 	= leftOffset + textWidth + (separator * 2);
			var barWidth 		= width - barLeftOffset;

			metrics 			= ctx.measureText(currentTime);
			textWidth 			= Math.round(metrics.width); 

			var barRightOffset 	= rightOffset + textWidth + (separator * 2);
			barWidth 			= barWidth - barRightOffset;

			progressBar.width 	= barWidth;
			progressBar.x 		= barLeftOffset;
			progressBar.y 		= Math.round((height / 2)) - (progressBar.height / 2);

			volumeBar.x 		= width - (separator) - volumeBar.width;
			volumeBar.y 		= Math.round((height / 2)) - (volumeBar.height / 2);

			playPauseButton.x 	= separator;
			playPauseButton.y 	= Math.round(height / 2) - Math.round(playPauseButton.height / 2);

			previousButton.x 	= playPauseButton.x + playPauseButton.width + separator;
			previousButton.y 	= Math.round(height / 2) - Math.round(previousButton.height / 2);

			nextButton.x 		= previousButton.x + previousButton.width + separator;
			nextButton.y 		= Math.round(height / 2) - Math.round(nextButton.height / 2);

			speakerButton.x 	= volumeBar.x - separator - speakerButton.width;
			speakerButton.y 	= Math.round((height / 2) - (speakerButton.height / 2));

			randomButton.x 		= speakerButton.x - separator - randomButton.width;
			randomButton.y 		= Math.round((height / 2) - (randomButton.height / 2));

			ctx.beginPath();
			ctx.rect(0, 0, width, height);
			ctx.fillStyle = 'black';
			ctx.fill();
			ctx.closePath();

			if (!audio.object.paused) {
				ctx.beginPath();
				ctx.rect(playPauseButton.x, playPauseButton.y, (playPauseButton.width / 2) - 2, playPauseButton.height);
				ctx.fillStyle = 'white';
				ctx.fill();
				ctx.closePath();

				ctx.beginPath();
				ctx.rect(playPauseButton.x + (playPauseButton.width / 2) + 2, playPauseButton.y, (playPauseButton.width / 2) - 2, playPauseButton.height);
				ctx.fillStyle = 'white';
				ctx.fill();
				ctx.closePath();
			} else {
				ctx.beginPath();
				ctx.fillStyle = 'white';
				ctx.moveTo(playPauseButton.x, playPauseButton.y);
				ctx.lineTo(playPauseButton.x, playPauseButton.y + playPauseButton.height);
				ctx.lineTo(playPauseButton.x + playPauseButton.width, playPauseButton.y + (playPauseButton.height / 2));
				ctx.fill();
				ctx.closePath();
			}

			ctx.beginPath();

			if (this.can.prev == true)
				ctx.fillStyle = 'white';
			else
				ctx.fillStyle = '#2E3436';

			ctx.moveTo(previousButton.x, previousButton.y + (previousButton.height / 2));
			ctx.lineTo(previousButton.x + (previousButton.width / 2) - 1, previousButton.y);
			ctx.lineTo(previousButton.x + (previousButton.width / 2) - 1, previousButton.y + previousButton.height);
			ctx.lineTo(previousButton.x, previousButton.y + (previousButton.height / 2));
			ctx.fill();
			ctx.moveTo(previousButton.x + (previousButton.width / 2) + 1, previousButton.y + (previousButton.height / 2));
			ctx.lineTo(previousButton.x + previousButton.width, previousButton.y);
			ctx.lineTo(previousButton.x + previousButton.width, previousButton.y + previousButton.height);
			ctx.lineTo(previousButton.x + (previousButton.width / 2) + 1, previousButton.y + (previousButton.height / 2));
			ctx.fill();
			ctx.closePath();

			ctx.beginPath();

			if (this.can.next == true)
				ctx.fillStyle = 'white';
			else
				ctx.fillStyle = '#2E3436';
			
			ctx.moveTo(nextButton.x, nextButton.y);
			ctx.lineTo(nextButton.x + (nextButton.width / 2) - 1, nextButton.y + (nextButton.height / 2))
			ctx.lineTo(nextButton.x, nextButton.y + nextButton.height);
			ctx.lineTo(nextButton.x, nextButton.y);
			ctx.fill();
			ctx.moveTo(nextButton.x + (nextButton.width / 2) + 1, nextButton.y);
			ctx.lineTo(nextButton.x + nextButton.width, nextButton.y + (nextButton.height / 2));
			ctx.lineTo(nextButton.x + (nextButton.width / 2) + 1, nextButton.y + nextButton.height);
			ctx.lineTo(nextButton.x + (nextButton.width / 2) + 1, nextButton.y);
			ctx.fill();
			ctx.closePath();

			ctx.beginPath();
			ctx.rect(progressBar.x, progressBar.y, progressBar.width, progressBar.height);
			ctx.fillStyle = '#2E3436';
			ctx.fill();
			ctx.closePath();

			ctx.beginPath();      
			ctx.rect(progressBar.x, progressBar.y, (progressBar.width / 100) * audio.bufferedProgress.end, progressBar.height);
			ctx.fillStyle = 'gray';
			ctx.fill();
			ctx.closePath();

			ctx.beginPath();      
			ctx.rect(progressBar.x, progressBar.y, (progressBar.width / 100) * audio.playedProgress, progressBar.height);
			ctx.fillStyle = 'white';
			ctx.fill();
			ctx.closePath();

			ctx.fillStyle = 'white';
			ctx.font = "12px Helvetica";
			ctx.fillText(durationTime, leftOffset + separator, (height / 2) + ((12.0 * 0.5) / 2.0) + 1);

			ctx.fillStyle = 'white';
			ctx.font = "12px Helvetica";
			ctx.fillText(currentTime, barWidth + barLeftOffset + separator, (height / 2) + ((12.0 * 0.5) / 2.0) + 1);

			ctx.beginPath();
			ctx.lineWidth = 0;
			ctx.moveTo(randomButton.x, randomButton.y + 2);
			ctx.lineTo(randomButton.x + ((randomButton.width / 2) - 4), randomButton.y + 2);
			ctx.lineTo(randomButton.x + ((randomButton.width / 2) + 4), randomButton.y + randomButton.height - 2);
			ctx.lineTo(randomButton.x + randomButton.width, randomButton.y + randomButton.height - 2);

			ctx.moveTo(randomButton.x + randomButton.width, randomButton.y + 2);
			ctx.lineTo(randomButton.x + randomButton.width - 3, randomButton.y);
			ctx.moveTo(randomButton.x + randomButton.width, randomButton.y + 2);
			ctx.lineTo(randomButton.x + randomButton.width - 3, randomButton.y + 4);

			ctx.moveTo(randomButton.x + randomButton.width, randomButton.y + randomButton.height - 2);
			ctx.lineTo(randomButton.x + randomButton.width - 3, randomButton.y + randomButton.height);
			ctx.moveTo(randomButton.x + randomButton.width, randomButton.y + randomButton.height - 2);
			ctx.lineTo(randomButton.x + randomButton.width - 3, randomButton.y + randomButton.height - 4);
			
			ctx.moveTo(randomButton.x, randomButton.y + randomButton.height - 2);
			ctx.lineTo(randomButton.x + ((randomButton.width / 2) - 4), randomButton.y + randomButton.height - 2);
			ctx.lineTo(randomButton.x + ((randomButton.width / 2) + 4), randomButton.y + 2);
			ctx.lineTo(randomButton.x + randomButton.width, randomButton.y + 2);

			if (audio.mode == PLAYER_MODE_NORMAL)
				ctx.strokeStyle = '#2E3436';
			else
				ctx.strokeStyle = 'white';

			ctx.stroke();
			ctx.closePath();

			ctx.beginPath();
			ctx.rect(speakerButton.x, speakerButton.y+4, speakerButton.width-8, speakerButton.height-8);

			if (audio.object.volume > 0)
				ctx.fillStyle = 'white';
			else
				ctx.fillStyle = '#2E3436';

			ctx.fill();
			ctx.closePath();
			ctx.beginPath();
			ctx.moveTo(speakerButton.x + speakerButton.width - 8, speakerButton.y+4);
			ctx.lineTo(speakerButton.x + speakerButton.width - 2 , speakerButton.y);
			ctx.lineTo(speakerButton.x + speakerButton.width - 2, speakerButton.y + speakerButton.height);
			ctx.lineTo(speakerButton.x + speakerButton.width - 8, speakerButton.y + speakerButton.height - 4);
			ctx.fill();
			ctx.closePath();
			ctx.beginPath();
			ctx.rect(speakerButton.x + speakerButton.width - 1, speakerButton.y + 3, 1, speakerButton.height - 6);
			ctx.fill();
			ctx.closePath();

			ctx.beginPath();
			ctx.rect(volumeBar.x, volumeBar.y, volumeBar.width, volumeBar.height);
			ctx.fillStyle = '#2E3436';
			ctx.fill();
			ctx.closePath();

			ctx.beginPath();
			ctx.rect(volumeBar.x, volumeBar.y, (volumeBar.width / 100) * (audio.object.volume * 100), volumeBar.height);
			ctx.fillStyle = 'white';
			ctx.fill();
			ctx.closePath();
		}
	}
};
</script>

<style>
	#player {
		width: 100%;
		height: 100%;
   		min-width: 830px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Player.vue